import { format, isToday, isTomorrow, parse } from 'date-fns';

import { type NextAvailableStoreSlot } from '@service-initiation/shared-clients-tech-care-services';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { monthPlusDayOfMonthFormat } from '@service-initiation/tech-care-utils-date-time';

import { type AppointmentDateAndTime } from '../types';

export const getNextAvailability = (
  appointment?: NextAvailableStoreSlot
): AppointmentDateAndTime | undefined => {
  if (!appointment) {
    return;
  }

  const appointmentDate = parse(appointment.date, 'yyyy-MM-dd', new Date());
  const formattedTime = appointment.at[0].start.toLocaleLowerCase();
  let formattedDateOrKey;

  if (isToday(appointmentDate)) {
    formattedDateOrKey = TranslationEntries.Repairs.DateAndTime.Today;
  } else if (isTomorrow(appointmentDate)) {
    formattedDateOrKey = TranslationEntries.Repairs.DateAndTime.Tomorrow;
  } else {
    formattedDateOrKey = format(appointmentDate, monthPlusDayOfMonthFormat);
  }

  return { formattedDateOrKey, formattedTime };
};
